import { render } from "./attachment_step.vue?vue&type=template&id=f5e0196c"
import script from "./attachment_step.vue?vue&type=script&lang=js"
export * from "./attachment_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/attachment_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5e0196c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5e0196c', __exports__)) {
    api.reload('f5e0196c', __exports__)
  }
  
  module.hot.accept("./attachment_step.vue?vue&type=template&id=f5e0196c", () => {
    api.rerender('f5e0196c', render)
  })

}


export default __exports__